import type { EffectsProp } from 'remotion';
import { buildVideoEffects } from './buildVideoEffects';
import { resolveActiveEffects } from './resolveActiveEffects';
import { EFFECT_LIBRARY } from './library/registry';
import { hashString } from './library/seededRandom';
import type { VideoEffects } from './types';

/** #429's base look, then every active section (array order = on top).
 *  The Effects switch (`enabled`) turns off only the base look
 *  (`buildVideoEffects` checks it); timeline sections always apply.
 *  `timeSec` is the clip output time; null means "outside the clip" (no sections).
 *  `frameAspect` is the composition width / height the footage is cover-fitted
 *  into: pixel-sized params scale to that visible frame (see pixelScaled). */
export function buildEffectStack(value: VideoEffects, timeSec: number | null, frame: number, frameAspect?: number): EffectsProp {
  const stack: Array<EffectsProp[number]> = [...buildVideoEffects(value, 1080, frameAspect)];
  for (const active of resolveActiveEffects(value.sections, timeSec)) {
    const entry = EFFECT_LIBRARY[active.section.effect];
    stack.push(...entry.build({
      k: active.k,
      params: active.section.params ?? {},
      localTime: active.localTime,
      duration: active.duration,
      frame,
      seed: hashString(active.section.id),
      frameAspect,
    }));
  }
  return stack;
}
